var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "document-item" }, [
    _c("div", { staticClass: "document-item__data" }, [
      _c("div", { staticClass: "document-item__name" }, [
        _vm._v(_vm._s(_vm.analyse.name)),
      ]),
      _vm.analyse.comment
        ? _c("div", { staticClass: "documents-group__description" }, [
            _vm._v(" " + _vm._s(_vm.analyse.comment) + " "),
          ])
        : _vm._e(),
    ]),
    _c(
      "div",
      { staticClass: "document-item__actions" },
      [
        _c("c-button-2", {
          staticClass: "document-item__edit",
          attrs: {
            id: `medical-analyse-edit-button-${
              _vm.analyse.name + _vm.analyse.id
            }`,
            size: "iconic",
            icon: "edit",
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "edit-medical-analyse",
                params: { id: _vm.analyse.id },
              })
            },
          },
        }),
        _c("c-button-2", {
          staticClass: "document-item__remove",
          attrs: {
            id: `medical-analyse-remove-button-${
              _vm.analyse.name + _vm.analyse.id
            }`,
            size: "iconic",
            icon: { icon: "trash", color: "secondary" },
          },
          on: { click: _vm.onRemove },
        }),
        _c("c-button-2", {
          staticClass: "document-item__move",
          attrs: {
            id: `medical-analyse-sort-button-${
              _vm.analyse.name + _vm.analyse.id
            }`,
            size: "iconic",
            icon: "arrows-constructor",
          },
        }),
        _c(
          "b-popover",
          {
            attrs: {
              placement: "top",
              triggers: "hover",
              target: `medical-analyse-edit-button-${
                _vm.analyse.name + _vm.analyse.id
              }`,
            },
          },
          [_vm._v(" Редактировать ")]
        ),
        _c(
          "b-popover",
          {
            attrs: {
              placement: "top",
              triggers: "hover",
              target: `medical-analyse-remove-button-${
                _vm.analyse.name + _vm.analyse.id
              }`,
            },
          },
          [_vm._v(" Удалить ")]
        ),
        _c(
          "b-popover",
          {
            attrs: {
              placement: "top",
              triggers: "hover",
              target: `medical-analyse-sort-button-${
                _vm.analyse.name + _vm.analyse.id
              }`,
            },
          },
          [_vm._v(" Переместить ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }